/* less/lib/less/tree/index */ function _(require, module, exports) {
    var tree = Object.create(null);
    tree.Node = require(232) /* ./node */;
    tree.Color = require(211) /* ./color */;
    tree.AtRule = require(208) /* ./atrule */;
    tree.DetachedRuleset = require(217) /* ./detached-ruleset */;
    tree.Operation = require(233) /* ./operation */;
    tree.Dimension = require(218) /* ./dimension */;
    tree.Unit = require(240) /* ./unit */;
    tree.Keyword = require(226) /* ./keyword */;
    tree.Variable = require(244) /* ./variable */;
    tree.Property = require(235) /* ./property */;
    tree.Ruleset = require(237) /* ./ruleset */;
    tree.Element = require(219) /* ./element */;
    tree.Attribute = require(209) /* ./attribute */;
    tree.Combinator = require(212) /* ./combinator */;
    tree.Selector = require(238) /* ./selector */;
    tree.Quoted = require(236) /* ./quoted */;
    tree.Expression = require(220) /* ./expression */;
    tree.Declaration = require(216) /* ./declaration */;
    tree.Call = require(210) /* ./call */;
    tree.URL = require(241) /* ./url */;
    tree.Import = require(222) /* ./import */;
    tree.mixin = {
        Call: require(228) /* ./mixin-call */,
        Definition: require(229) /* ./mixin-definition */
    };
    tree.Comment = require(213) /* ./comment */;
    tree.Anonymous = require(206) /* ./anonymous */;
    tree.Value = require(242) /* ./value */;
    tree.JavaScript = require(224) /* ./javascript */;
    tree.Assignment = require(207) /* ./assignment */;
    tree.Condition = require(214) /* ./condition */;
    tree.Paren = require(234) /* ./paren */;
    tree.Media = require(227) /* ./media */;
    tree.UnicodeDescriptor = require(239) /* ./unicode-descriptor */;
    tree.Negative = require(231) /* ./negative */;
    tree.Extend = require(221) /* ./extend */;
    tree.VariableCall = require(243) /* ./variable-call */;
    tree.NamespaceValue = require(230) /* ./namespace-value */;
    module.exports = tree;
}
